export const BOYACA_MUNICIPALITIES = [
    'Almeida',
    'Aquitania',
    'Arcabuco',
    'Belén',
    'Berbeo',
    'Betéitiva',
    'Boavita',
    'Boyacá',
    'Briceño',
    'Buenavista',
    'Busbanzá',
    'Caldas',
    'Campohermoso',
    'Cerinza',
    'Chinavita',
    'Chiquinquirá',
    'Chíquiza',
    'Chiscas',
    'Chita',
    'Chitaraque',
    'Chivatá',
    'Chivor',
    'Ciénega',
    'Cómbita',
    'Coper',
    'Corrales',
    'Covarachía',
    'Cubará',
    'Cucaita',
    'Cuítiva',
    'Duitama',
    'El Cocuy',
    'El Espino',
    'Firavitoba',
    'Floresta',
    'Gachantivá',
    'Gámeza',
    'Garagoa',
    'Guacamayas',
    'Guateque',
    'Guayatá',
    'Güicán',
    'Iza',
    'Jenesano',
    'Jericó',
    'La Capilla',
    'La Uvita',
    'La Victoria',
    'Labranzagrande',
    'Macanal',
    'Maripí',
    'Miraflores',
    'Mongua',
    'Monguí',
    'Moniquirá',
    'Motavita',
    'Muzo',
    'Nobsa',
    'Nuevo Colón',
    'Oicatá',
    'Otanche',
    'Pachavita',
    'Páez',
    'Paipa',
    'Pajarito',
    'Panqueba',
    'Pauna',
    'Paya',
    'Paz de Río',
    'Pesca',
    'Pisba',
    'Puerto Boyacá',
    'Quípama',
    'Ramiriquí',
    'Ráquira',
    'Rondón',
    'Saboyá',
    'Sáchica',
    'Samacá',
    'San Eduardo',
    'San José de Pare',
    'San Luis de Gaceno',
    'San Mateo',
    'San Miguel de Sema',
    'San Pablo de Borbur',
    'Santa María',
    'Santa Rosa de Viterbo',
    'Santa Sofía',
    'Santana',
    'Sativanorte',
    'Sativasur',
    'Siachoque',
    'Soatá',
    'Socha',
    'Socotá',
    'Sogamoso',
    'Somondoco',
    'Sora',
    'Soracá',
    'Sotaquirá',
    'Susacón',
    'Sutamarchán',
    'Sutatenza',
    'Tasco',
    'Tenza',
    'Tibaná',
    'Tibasosa',
    'Tinjacá',
    'Tipacoque',
    'Toca',
    'Togüí',
    'Tópaga',
    'Tota',
    'Tunja',
    'Tununguá',
    'Turmequé',
    'Tuta',
    'Tutazá',
    'Úmbita',
    'Ventaquemada',
    'Villa de Leyva',
    'Viracachá',
    'Zetaquira'
];

export default BOYACA_MUNICIPALITIES;